import { Accordion, AccordionDetails, AccordionSummary, useTheme } from "@mui/material";
import { ChevronRight } from "@mui/icons-material";
import { useState } from "react";
import { IStringContext } from "../../../../../../StringContext";
import styles from "./RepaymentPlan.module.scss";
import { BNBox } from "@bn-monorepo/js-packages";
import { RepaymentPlanYear } from "@bn-monorepo/js-packages/src/Helpers/calculators/calculateLoan";

interface Props {
  repaymentPlan: RepaymentPlanYear[];
  strings: IStringContext;
  formatter: (number) => string;
  isActive: boolean;
}
const RepaymentPlan: React.FC<Props> = (props) => {
  const classes = props.isActive ? styles.repaymentPlanContainerActive : styles.repaymentPlanContainer;

  const months = new Map<number, string>([
    [1, props.strings.repaymentPlan_January],
    [2, props.strings.repaymentPlan_February],
    [3, props.strings.repaymentPlan_March],
    [4, props.strings.repaymentPlan_April],
    [5, props.strings.repaymentPlan_May],
    [6, props.strings.repaymentPlan_June],
    [7, props.strings.repaymentPlan_July],
    [8, props.strings.repaymentPlan_August],
    [9, props.strings.repaymentPlan_September],
    [10, props.strings.repaymentPlan_October],
    [11, props.strings.repaymentPlan_November],
    [12, props.strings.repaymentPlan_December],
  ]);

  const theme = useTheme();

  const [visibleYears, setVisibleYears] = useState(props.repaymentPlan.map(() => false));

  const toggleRepaymentPlanYear = (i: number) => {
    setVisibleYears((visibleYears) => {
      return [...visibleYears.slice(0, i), (visibleYears[i] = !visibleYears[i]), ...visibleYears.slice(i + 1)];
    });
  };

  const transform = (index) =>
    visibleYears[index] ? "rotate(90deg) translateY(-0.2rem)" : "rotate(0) translateY(-0.2rem) ";

  return (
    <div className={classes}>
      {props.repaymentPlan.map((item, i) => (
        <Accordion onChange={() => toggleRepaymentPlanYear(i)} defaultExpanded={false} key={`${item.year}`}>
          <AccordionSummary>
            <div className={styles.customAccordionSummary}>
              <div>{item.year}</div>
              <div
                style={{
                  display: "flex",
                  alignSelf: "center",
                  alignItems: "center",
                  marginTop: 1,
                  marginBottom: -1,
                }}
              >
                <strong>{`${
                  props.strings.loanCalculator_OutstandingDebt
                } ${props.formatter(item.outstanding)}`}</strong>
                <div
                  style={{
                    display: "flex",
                    cursor: "pointer",
                    marginTop: 1,
                    marginBottom: -1,
                  }}
                >
                  <ChevronRight
                    style={{
                      fontSize: "2.4rem",
                      fontWeight: "normal",
                      color: "#003d50",
                      transform: transform(i),
                      transition: "all .4s cubic-bezier(0,.1,.5,.9)",
                    }}
                  />
                </div>
              </div>
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <BNBox
              className={styles.repaymentplanGrid}
              sx={{
                "div > span": {
                  backgroundColor: theme.vars.palette.secondary.light,
                  borderColor: theme.vars.palette.secondary.light,
                  borderWidth: "0.2rem",
                },
              }}
            >
              <span>{props.strings.repaymentPlan_Month}</span>
              <span className={styles.columnRight}>{props.strings.repaymentPlan_Total}</span>
              <span className={styles.columnRight}>{props.strings.loanCalculator_OfWhichInterest}</span>
              <span className={styles.columnRight}>{props.strings.repaymentPlan_Interest}</span>
              <span className={styles.columnRight}>{props.strings.repaymentPlan_Payment}</span>
              <span className={styles.columnRight}>{props.strings.repaymentPlan_TermFee}</span>
              <span className={styles.columnRight}>
                <strong>{props.strings.repaymentPlan_Total}</strong>
              </span>
              {item.months.map((row) => (
                <div key={`${row.monthNum}`} className={styles.rowContainer}>
                  <span>{months.get(row.monthNum)}</span>
                  <span className={styles.columnRight}>{props.formatter(row.totalAmount)}</span>
                  <span className={styles.columnRight}>{props.formatter(row.interestAmount)}</span>
                  <span className={styles.columnRight}>{props.formatter(row.interestAmount)}</span>
                  <span className={styles.columnRight}>{props.formatter(row.repaymentAmount)}</span>
                  <span className={styles.columnRight}>{props.formatter(row.installmentFee)}</span>
                  <span className={styles.columnRight}>
                    <strong>{props.formatter(row.totalAmount)}</strong>
                  </span>
                </div>
              ))}
            </BNBox>
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
};
export default RepaymentPlan;
